import { useEffect, Suspense, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router";
import { Box, Stack } from "@mui/material";
import SideDrawer from "../drawer/SideDrawer";
import AppHeader from "./AppHeader";
import ThreeDotsLoader from "../loader/ThreeDotsLoader";
import { getMeta } from "../../redux/features/meta/metaSlice";
import { SHELL_PADDING, shellPaperSx } from "./layoutStyles";

const MainLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMeta() as any);
  }, [dispatch]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "grey.100",
        p: SHELL_PADDING,
      }}
    >
      <Box sx={shellPaperSx}>
        <SideDrawer
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />
        <Stack flex={1} minWidth={0} sx={{ maxHeight: "100vh", overflow: "hidden" }}>
          <AppHeader
            showMenuButton
            onMenuClick={() => setMobileOpen(true)}
          />
          <Box
            component="main"
            sx={{
              flex: 1,
              overflow: "auto",
              bgcolor: "grey.50",
              px: { xs: 2, sm: 3, md: 3.5 },
              py: { xs: 2.5, md: 3.5 },
            }}
          >
            <Suspense fallback={<ThreeDotsLoader variant="page" />}>
              <Outlet />
            </Suspense>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default MainLayout;
